import { ClientResponse } from '@givz/core-client/dist/client/utils';
import { accessTokenInvalidatedState } from '@states';
import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

export const useCoreClientSafe = () => {
  const [, setAccessTokenInvalidated] = useRecoilState(
    accessTokenInvalidatedState,
  );

  const coreClientSafe = useCallback(
    async <T, I>(params: {
      args: I;
      fn: (args: I) => Promise<ClientResponse<T>>;
      messageOnError?: string;
    }): Promise<ClientResponse<T>> => {
      const { args, fn, messageOnError } = params;

      try {
        const response = await fn(args);
        const { errors } = response;

        const [firstError] = errors ?? [];

        if (firstError && firstError.code === 401) {
          setAccessTokenInvalidated(true);
        }

        return response;
      } catch (error) {
        return {
          errors: [
            {
              message: messageOnError ?? 'There was an issue, please try again',
            },
          ],
        } as unknown as ClientResponse<T>;
      }
    },
    [setAccessTokenInvalidated],
  );

  return coreClientSafe;
};
